module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp03-c9d6251f32f42653147db944065f58ae.jpg";